function verifica_token_storage() {
    var acces_token = localStorage.getItem('access')

    while(acces_token===null){
        acces_token = localStorage.getItem('access');
    }

    const headers = {
        Authorization: `Bearer ${acces_token}`
    }

    return headers;
}

export default verifica_token_storage;